import React,{lazy,Suspense} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiUpload,FiSearch,FiPhone,FiCheckCircle,FiPlayCircle}=FiIcons;

const HowItWorks=()=> {
  const steps=[
    {
      icon: FiUpload,
      title: "Upload Your Current Bill",
      description: "Securely upload your current NYC business internet statement from Verizon, Spectrum, Comcast, Optimum, or other providers. We'll compare it against the average internet bill NYC businesses pay to identify potential savings."
    },
    {
      icon: FiSearch,
      title: "We Analyze Your Account",
      description: "Our Manhattan business internet experts review your current plan, usage, and contract terms. We'll show you how to negotiate your internet bill effectively with data-driven insights."
    },
    {
      icon: FiPhone,
      title: "We Negotiate For You",
      description: "Using our direct relationships with NYC business internet service provider reps, we handle all negotiations on your behalf. No need to learn how to negotiate internet bill terms yourself."
    },
    {
      icon: FiCheckCircle,
      title: "You Save Money",
      description: "Enjoy reduced monthly bills with the same or better service. Our lower internet bill consultation process delivers average savings of 30-50% on NYC business internet costs."
    }
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-white mb-4">How Our NYC Business Internet Bill Reduction Works</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Our proven process has helped hundreds of NYC and Hudson Valley businesses reduce their internet costs through professional provider negotiations. 
            Many businesses don't realize they're paying above the average internet bill NYC rates.
          </p>
        </motion.div>

        {/* Video Section - Lazy loaded */}
        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="mb-16"
        >
          <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 hover:border-red-500 transition-colors duration-300">
            <h3 className="text-2xl font-semibold text-white mb-4 text-center">
              <SafeIcon icon={FiPlayCircle} className="inline-block mr-2 text-red-400" />
              Are You Overpaying For NYC Business Internet Service?
            </h3>
            <p className="text-gray-300 mb-4 text-center">
              Most Manhattan business internet users don't realize how much they're overpaying compared to the average internet bill NYC businesses should expect. 
              Watch this quick video to learn more about how to negotiate your internet bill effectively.
            </p>
            <div className="max-w-4xl mx-auto">
              <div style={{position: 'relative',aspectRatio: '16/9'}}>
                <iframe
                  loading="lazy"
                  title="Gumlet video player"
                  src="https://play.gumlet.io/embed/68712c0b3f4637e353f65cf2?background=false&autoplay=false&loop=false&disableControls=false"
                  style={{border: 'none',position: 'absolute',top: 0,left: 0,height: '100%',width: '100%'}}
                  allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;fullscreen;"
                  fetchpriority="low"
                >
                </iframe>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,y: 50}}
              whileInView={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: index * 0.2}}
              className="bg-gray-900 p-6 rounded-xl border border-gray-700 hover:border-red-500 transition-colors duration-300"
            >
              <div className="text-center">
                <div className="bg-gradient-to-r from-red-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={step.icon} className="text-2xl text-white" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                <p className="text-gray-400">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;